import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import config from '../../appConfig';
import { ConfigContext } from '../../Context/ConfigContext';
import Config from '../../appConfig';

const DashboardAccount = ({
    businessInfo,
    statementDueAmount,
    dashboardData,
    statementDueDays,
    statementDueDate
}) => {

    const navigate = useNavigate();

    const { currency } = useContext(ConfigContext);

    const creditBalance = Number(businessInfo.business_credit_balance ?? 0) || 0;
    const creditLimit = Number(businessInfo.business_credit_limit ?? 0) || 0;
    const usedCredit = creditLimit > 0 ? creditLimit - creditBalance : 0;
    const percentUsed = creditLimit > 0 ? ((usedCredit / creditLimit) * 100).toFixed(1) : 0;
    const percentAvailable = creditLimit > 0 ? ((creditBalance / creditLimit) * 100).toFixed(1) : 0;

    return (
        <div className="col-md-6 ml-3" style={{ width: '860px', flex: '0 0 860px', maxWidth: '860px', backgroundColor: '#transparent', height: '361px', }}>
            <div className="row mt-2">
                <div className="col-md-6" style={{ width: '50%' }}>
                    <h4 className="ml-2">My Account Dashboard</h4>
                </div>

                <div className="col-md-6" style={{ width: '50%' }}>

                    <div className="row">
                        <div className="col-md-12 d-flex justify-content-end">
                            {
                                currency?.toLowerCase() !== "aed" &&
                                currency?.toLowerCase() !== "sar" &&
                                <button
                                    type="button"
                                    className="btn btn-outline-info btn-sm mr-3"
                                    onClick={() => navigate("/Spare-Parts/BulkPricing")}
                                >
                                    <i className="fas fa-file-excel mr-2"></i> Upload Bulk Price
                                </button>
                            }

                            {
                                currency?.toLowerCase() !== "usd" &&
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-outline-success btn-sm mr-3"
                                        onClick={() => navigate("/MyAccount/CreditApplication")}
                                    >
                                        <i className="fas fa-credit-card mr-2"></i> Apply For Credit
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm mr-3"
                                        onClick={() => navigate("/MyAccount/RequestStatementAccount")}
                                        style={{
                                            border: '1px solid',
                                            float: 'right',
                                            marginRight: '13px',
                                        }}
                                    >
                                        <i className="fas fa-paper-plane"></i> View Statement of Account
                                    </button>
                                </>
                            }
                        </div>

                    </div>
                </div>

            </div>
            <div className="row">
                <div className="col-md-5 card mr-1" style={{ width: '400px', flex: '0 0 400px', maxWidth: '400px', height: '297px', backgroundColor: 'transparent', border: '1px solid #dcdcdc', zIndex: 1, position: 'relative', overflow: 'hidden' }}>
                    <div className="card-body">
                        <h6 style={{ color: '#000', margin: '5px 0' }}>Customer Name: {businessInfo.business_name ?? businessInfo.business_name}</h6>

                        <h6 style={{ color: '#000', margin: '5px 0' }}>Registration ID: GHY-{localStorage.getItem("business_id")}</h6>
                        {
                            currency?.toLowerCase() !== "usd" &&
                            <>
                                <h6 style={{ color: '#000', margin: '5px 0' }}>Credit Balance: {businessInfo.business_credit_balance ? businessInfo.business_credit_balance : 0}  {config.currency}</h6>

                                <h6 style={{ color: '#000', margin: '5px 0' }}>
                                    Used Credit: {businessInfo.business_credit_used ? parseFloat(businessInfo.business_credit_used).toFixed(2) : 0} {config.currency}
                                </h6>
                                <h6 style={{ color: '#000', margin: '5px 0' }}>Reward Points: {businessInfo.business_reward_points_balance ? businessInfo.business_reward_points_balance : 0}</h6>
                                {
                                    statementDueAmount > 0 && <h6 style={{ color: '#ca0303ff', margin: '0px 0' }}>Statement Due in: <span className="blinking-text">{statementDueDays} days</span></h6>
                                }


                                {
                                    statementDueDate && statementDueAmount > 0 && <h6 style={{ color: '#ca0303ff', margin: '0px 0' }}>Statement Due Date: {statementDueDate}</h6>
                                }

                                {
                                    statementDueAmount > 0 && <h6 style={{ color: '#ca0303ff', margin: '2px 0' }}>Total Due Amount: {statementDueAmount.toFixed(2)} {config.currency}</h6>
                                }
                            </>
                        }

                    </div>
                </div>

                <div className="row ml-1" style={{ width: '450px', flex: '0 0 450px', maxWidth: '450px', height: '297px' }}>

                    <div className="col-md-5 ml-5 card d-flex align-items-center justify-content-center" style={{ height: '134px', backgroundColor: 'transparent', }}>
                        <div className="text-center" style={{ width: '100%' }}>
                            <h4 style={{ color: '#2baab1', margin: 'auto', color: '#000' }}>{dashboardData.totalOrders ? dashboardData.totalOrders : 0}</h4>
                            <div style={{ width: '70px', height: '70px', overflow: 'hidden', borderRadius: '50%', margin: 'auto' }}>
                                <img
                                    src="./animated/all order_gif.gif"
                                    alt="Total Orders"
                                    style={{
                                        width: '110%',
                                        height: '120%',
                                        objectFit: 'cover',
                                        border: 'none',
                                        outline: 'none',
                                        marginTop: '-10px',
                                    }}
                                />
                            </div>
                            <h5 style={{ color: '#000', margin: '4px 0', color: '#000' }}>Total Orders</h5>

                        </div>
                    </div>
                    <div className="col-md-5 ml-5 card d-flex align-items-center justify-content-center" style={{ height: '134px', backgroundColor: '#FFF' }}>

                        <div style={{ width: '100%' }}>
                            <div style={{ position: 'absolute', bottom: 0, fontSize: '12px' }}>
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'left'
                                    }}>
                                    <div
                                        style={{
                                            width: '30px',
                                            height: '15px',
                                            backgroundColor: '#444',
                                            position: 'absolute',
                                            marginTop: '2px',
                                            fontWeight: 'bold',
                                            color: '#FFF',
                                            fontSize: '8px',
                                            textAlign: 'center',
                                            verticalAlign: 'middle',
                                            paddingTop: '2px'
                                        }}>
                                        {percentAvailable}%
                                    </div>
                                    <h5
                                        style={{
                                            color: '#444', margin: '4px 0', marginLeft: '40px'
                                        }}> Available Credit</h5></div>
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'left'
                                    }}>
                                    <div
                                        style={{
                                            width: '30px',
                                            height: '15px',
                                            backgroundColor: '#000',
                                            position: 'absolute',
                                            marginTop: '2px',
                                            fontWeight: 'bold',
                                            color: '#FFF',
                                            fontSize: '8px',
                                            textAlign: 'center',
                                            verticalAlign: 'middle',
                                            paddingTop: '2px'
                                        }}>
                                        {percentUsed}%
                                    </div>
                                    <h5
                                        style={{
                                            color: '#000', margin: '4px 0', marginLeft: '40px'
                                        }}> Used Credit</h5></div>
                            </div>

                            <img
                                src="./animated/tire.gif"
                                alt="Total Orders"
                                style={{
                                    width: '110%',
                                    height: '120%',
                                    objectFit: 'cover',
                                    border: 'none',
                                    outline: 'none',
                                    marginTop: '-10px',
                                }}
                            />


                        </div>

                    </div>

                    <div className="col-md-5 ml-5 card d-flex align-items-center justify-content-center" style={{ height: '134px', overflow: 'hidden', backgroundColor: 'transparent', zIndex: 2 }}>

                        <div className="text-center" style={{ width: '100%' }}>
                            <h4 style={{ /* color: '#2baab1', */ margin: 'auto', color: '#000' }}>{dashboardData.inProcessOrders ? dashboardData.inProcessOrders : 0}</h4>
                            <div style={{ width: '100%', height: '70px', overflow: 'hidden', }}>

                            </div>
                            <h5 style={{ color: '#000', margin: '4px 0', }}>Processing Orders</h5>

                        </div>

                    </div>

                    <div className="col-md-5 ml-5 card d-flex align-items-center justify-content-center" style={{ height: '134px', overflow: 'hidden', backgroundColor: 'transparent', zIndex: 2 }}>

                        <div className="text-center" style={{ width: '100%' }}>
                            <h4 style={{ color: '#2baab1', margin: 'auto', color: '#000' }}>{dashboardData.totalDelivered ? dashboardData.totalDelivered : 0}</h4>
                            <div style={{ width: '100%', height: '70px', overflow: 'hidden', }}>

                            </div>
                            <h5 style={{ color: '#000', margin: '4px 0', color: '#000' }}>Delivered Orders</h5>

                        </div>
                    </div>
                </div>

                <img
                    src={`${Config.country === "uae" ? "./animated/van_loading.gif" : Config.country === "ksa" ? "/assets/images/gif/van_full_ride.gif" : ""}`}
                    alt="Truck"
                    style={{ bottom: 30, position: 'absolute' }}
                />
            </div>
        </div>
    )
}

export default DashboardAccount
